import { AnnotatedType } from '@/components/annotated-type';
import { StoryQuestion, useStoryQuestion } from '@/components/microstory/question';
import { CenteredStoryText } from '@/components/microstory/text';
import { select, t, Trans } from '@lingui/macro';

export function TheOtherClimateCrisis2023Chapter1() {
  const answers = [
    {
      id: 'seventy',
      label: t({ id: `the-other-climate-crisis-2023.chapter-1.question.answer-1`, message: '70%' }),
    },
    {
      id: 'eightyFive',
      label: t({ id: `the-other-climate-crisis-2023.chapter-1.question.answer-2`, message: '85%' }),
    },
    {
      id: 'ninetyFive',
      label: t({ id: `the-other-climate-crisis-2023.chapter-1.question.answer-3`, message: '95%' }),
    },
  ];

  const { selectedAnswer, handleAnswer } = useStoryQuestion<(typeof answers)[number]>();

  return (
    <>
      <StoryQuestion
        question={t({
          id: `the-other-climate-crisis-2023.chapter-1.question.question`,
          message:
            'We first asked young people aged 15-24 whether they had heard of climate change. How many do you think answered yes?',
        })}
        answers={answers}
        selectedAnswer={selectedAnswer}
        onAnswer={handleAnswer}
        response={
          selectedAnswer?.id &&
          t({
            id: `the-other-climate-crisis-2023.chapter-1.question.response`,
            message: select(selectedAnswer.id, {
              seventy: 'Nope!',
              eightyFive: "That's right!",
              ninetyFive: 'Afraid not!',
            }),
          })
        }
      />
      <CenteredStoryText>
        <Trans id="the-other-climate-crisis-2023.chapter-1.text-1">
          On average, <AnnotatedType>only 85%</AnnotatedType> of young people say they've heard of
          climate change.
        </Trans>
      </CenteredStoryText>
    </>
  );
}
